import { useState, useContext } from "react";
import { loginUser } from "../services/auth";
import { AuthContext } from "../context/AuthContext";
import "./login.css"; // 👉 ADD THIS

export default function Login() {
    const { login } = useContext(AuthContext);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = async () => {
        try {
            const data = await loginUser(username, password);
            login(data.access, data.refresh);
            window.location.href = "/";
        } catch (err) {
            setError("Invalid login");
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <h2 className="login-title">Super Admin Login</h2>

                <input
                    type="text"
                    placeholder="Username"
                    className="login-input"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />

                <input
                    type="password"
                    placeholder="Password"
                    className="login-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button className="login-btn" onClick={handleLogin}>
                    Login
                </button>

                {error && <p className="login-error">{error}</p>}
            </div>
        </div>
    );
}
